import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { uniqueId } from '../../../utils/uniqueId.es.js';
import { TextInput } from '../../forms/TextInput/TextInput.es.js';

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const Styles = labelStyles("SubscriptionForm", {
  root: css`
    display: flex;
    flex-direction: column;
    gap: var(--zds-space-8);
    margin: 0 auto;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      margin: 0;
      align-items: center;
      flex-direction: row;
    }
  `,
  inputField: (fluidInput) => css`
    display: flex;
    text-align: left;
    ${fluidInput && withModifier("fluid", css`
        flex: 1 100%;
        @media screen and (min-width: ${breakpoints.tablet}px) {
          flex: 2;
        }
      `)}
  `
});
const SubscriptionForm = (_a) => {
  var { inputIsFullWidth = true, fluidInput = false } = _a, props = __rest(_a, ["inputIsFullWidth", "fluidInput"]);
  const [id] = useState(props.inputId || uniqueId("SubscriptionForm-"));
  const [subscribedValue, setSubscribedValue] = useState("");
  const inputSize = "medium";
  const inputProps = {
    id,
    isDisabled: props.inputIsDisabled,
    isErrored: !!props.inputError,
    isRequired: props.inputIsRequired,
    isFullWidth: inputIsFullWidth,
    placeholder: props.placeholderText,
    ariaLabel: props.placeholderText,
    size: inputSize,
    onChange: (event) => setSubscribedValue(event.target.value)
  };
  return jsx(
    "form",
    { onSubmit: () => {
      var _a2;
      return (_a2 = props.onSubmit) === null || _a2 === void 0 ? void 0 : _a2.call(props, subscribedValue);
    }, "data-testid": "subscription-form", "data-zds": true },
    jsx(
      "div",
      { css: Styles.root, "data-zds": true },
      jsx("div", { css: Styles.inputField(fluidInput), "data-zds": true }, props.renderInput ? props.renderInput(inputProps) : jsx(TextInput, Object.assign({}, inputProps))),
      props.renderButton({ size: "medium" })
    )
  );
};

export { SubscriptionForm };
//# sourceMappingURL=SubscriptionForm.es.js.map
